<div class="ranking-view">
  <div class="ranking-view__list" cdkTrapFocus cdkDropList (cdkDropListDropped)="drop($event)">
    @for (option of options$(); track option.id; let index = $index, last = $last) {
      <div cdkDrag class="ranking-view__list__option-container">
        <span class="ranking-view__list__option-container-order fs__xl">{{ index + 1 }}</span>
        <div class="ranking-view__list__option-container-box">
          <span cdkDragHandle class="ranking-view__list__option-container-box-content">
            <fa-icon [icon]="faGripDotsVertical" [title]="'system.rankingQuestion.reorderOption' | translate"></fa-icon>
            <div class="ranking-view__list__option-container-box-content-title survey-viewer__html-content fs__xl" [innerHTML]="option.text"></div>
          </span>
          <span class="ranking-view__list__option-container-box-actions">
            <button
              mat-icon-button
              [title]="'system.rankingQuestion.moveCardUp' | translate"
              class="next-btn"
              [disabled]="index === 0"
              (click)="onMoveCard(index, index - 1)"
            >
              <fa-icon [icon]="faCaretUp"></fa-icon>
            </button>
            <button
              mat-icon-button
              [title]="'system.rankingQuestion.moveCardDown' | translate"
              class="next-btn"
              [disabled]="last"
              (click)="onMoveCard(index, index + 1)"
            >
              <fa-icon [icon]="faCaretDown"></fa-icon>
            </button>
          </span>
        </div>
      </div>
    }
  </div>
</div>
